import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NotUsingCreditsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "NotUsingCredits",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10.857 32C4.87 32 0 27.13 0 21.143c0-3.956 2.153-7.6 5.622-9.514a1.134 1.134 0 0 1 1.552.449 1.14 1.14 0 0 1-.45 1.551 8.59 8.59 0 0 0-4.439 7.514c0 4.725 3.846 8.571 8.571 8.571a8.58 8.58 0 0 0 7.539-4.484 1.15 1.15 0 0 1 1.55-.458c.554.302.76.996.458 1.552A10.87 10.87 0 0 1 10.856 32M25.87 20.489c-.4 0-.79-.212-.998-.587a1.14 1.14 0 0 1 .442-1.554 8.58 8.58 0 0 0 4.4-7.49c0-4.726-3.846-8.572-8.571-8.572a8.58 8.58 0 0 0-7.53 4.473c-.299.556-.995.76-1.548.455a1.14 1.14 0 0 1-.456-1.549A10.85 10.85 0 0 1 21.142 0C27.13 0 32 4.87 32 10.857c0 3.935-2.137 7.572-5.574 9.487a1.14 1.14 0 0 1-.556.145Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.082 13.714q-.154 0-.308-.042a1.143 1.143 0 0 1-.792-1.409c.107-.38.16-.772.16-1.167a4.242 4.242 0 0 0-5.402-4.078 1.13 1.13 0 0 1-1.41-.786 1.14 1.14 0 0 1 .785-1.41 6.53 6.53 0 0 1 8.067 8.058c-.143.504-.6.834-1.1.834M28.571 29.714c-.292 0-.585-.111-.808-.335L2.62 4.237A1.142 1.142 0 1 1 4.236 2.62l25.143 25.143a1.142 1.142 0 0 1-.808 1.95M10.636 27.429a6.287 6.287 0 0 1-6.281-6.281 6.3 6.3 0 0 1 5.008-6.15c.59-.14 1.224.268 1.349.889a1.14 1.14 0 0 1-.889 1.348 4.01 4.01 0 0 0-3.183 3.913 4 4 0 0 0 3.995 3.995 3.99 3.99 0 0 0 3.93-3.268 1.154 1.154 0 0 1 1.33-.92c.62.114 1.033.71.919 1.33a6.275 6.275 0 0 1-6.179 5.144Z"
    })]
  }));
};
NotUsingCreditsIcon.displayName = 'NotUsingCreditsIcon';